export const NODE_META_KEYS = [
  "version",
  "validFrom",
  "validTo",
  "createdAt",
  "updatedAt",
  "deletedAt",
] as const;

export const EDGE_META_KEYS = [
  "validFrom",
  "validTo",
  "createdAt",
  "updatedAt",
  "deletedAt",
] as const;
